// extracted by mini-css-extract-plugin
export var statItem = "_cc-1";
export var statsRow = "_cc-0";